import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/Context";

const AskQuestion = () => {
  const [userData] = useContext(UserContext);
  const [form, setForm] = useState({
    question: "",
    question_description: "",
    tags: "general",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const apiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5001";

  useEffect(() => {
    if (!userData?.user) {
      navigate("/login");
    }
  }, [userData, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!form.question.trim() || !form.question_description.trim()) {
      setErrorMessage("Please provide both a question title and description.");
      return;
    }

    try {
      setIsSubmitting(true);

      await axios.post(
        `${apiBaseUrl}/api/questions/`,
        {
          ...form,
          user_id: userData?.user?.id,
        },
        {
          headers: {
            "x-auth-token": localStorage.getItem("auth-token") || "",
          },
        },
      );

      navigate("/");
    } catch (error) {
      const message =
        error?.response?.data?.msg ||
        "Unable to submit question right now. Please try again.";
      setErrorMessage(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-gray-100 w-full py-8 px-4 md:px-16">
      <div className="max-w-3xl mx-auto bg-white rounded-md shadow-sm p-6 md:p-8">
        <h1 className="text-2xl font-semibold mb-2">Ask a Public Question</h1>
        <p className="text-gray-600 mb-6">
          Be specific and imagine you are asking a question to another person.
        </p>

        {errorMessage ? (
          <p className="text-red-600 text-sm mb-4">{errorMessage}</p>
        ) : null}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Title
            </label>
            <input
              type="text"
              name="question"
              value={form.question}
              onChange={handleChange}
              className="w-full border rounded p-2"
              placeholder="e.g. How to use async/await in JavaScript?"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Description
            </label>
            <textarea
              name="question_description"
              value={form.question_description}
              onChange={handleChange}
              className="w-full border rounded p-2 min-h-36"
              placeholder="Describe your problem with details..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tags
            </label>
            <input
              type="text"
              name="tags"
              value={form.tags}
              onChange={handleChange}
              className="w-full border rounded p-2"
              placeholder="e.g. javascript, react"
            />
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-orange-500 disabled:opacity-50"
          >
            {isSubmitting ? "Posting..." : "Post Your Question"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AskQuestion;
